import myAxios from "../_services/axiositeachWrapper";
import Config from "../_config/config";

export interface ResolvedPage {
  canView: boolean;
  canAdmin: boolean;
  elements: Record<string, boolean>;
}

export interface ResolvedAccessControl {
  isAdmin: boolean;
  userRoleIds: number[];
  pages: Record<string, ResolvedPage>;
}

export interface AdminPageConfig {
  viewRoleIds?: number[];
  adminRoleIds?: number[];
  elements?: Record<string, number[]>;
}

export interface AdminAccessControlConfig {
  pages: Record<string, AdminPageConfig>;
}

export interface RoleOption {
  id: number;
  name: string;
}

const baseUrl = `${Config.nodeSiteUrl}v1/access-control`;

export async function fetchResolvedAccessControl(): Promise<ResolvedAccessControl> {
  const res = await myAxios.get<{ success: boolean; data: ResolvedAccessControl }>(`${baseUrl}/config`);
  return res.data.data;
}

export async function fetchAdminConfig(): Promise<AdminAccessControlConfig> {
  const res = await myAxios.get<{ success: boolean; data: AdminAccessControlConfig }>(
    `${baseUrl}/admin/config`,
  );
  return res.data.data;
}

export async function saveAdminPageConfig(
  pageKey: string,
  pageConfig: AdminPageConfig,
): Promise<void> {
  await myAxios.put(
    `${baseUrl}/admin/config/page/${encodeURIComponent(pageKey)}`,
    pageConfig,
  );
}

/** Reuses the existing portlet endpoint for active role list. */
export async function fetchRoles(): Promise<RoleOption[]> {
  const res = await myAxios.get<{ success: boolean; data: RoleOption[] }>(
    `${Config.nodeSiteUrl}v1/portlets/roles`,
  );
  return res.data.data ?? [];
}
